import type { Message, ReferenceCard } from "../types";

export function getReferenceCards(message: Message): ReferenceCard[] {
  if (!Array.isArray(message.reference_cards)) return [];
  return message.reference_cards.filter(
    (card): card is ReferenceCard =>
      !!card && typeof card === "object" && typeof card.id === "string",
  );
}

export function hasRenderableReferenceCards(message: Message): boolean {
  return getReferenceCards(message).length > 0;
}

// Prefer HTML fields from the Quick Card API; fall back to plain / markdown.
export function getReferenceCardShortAnswer(card: ReferenceCard): string {
  const html = card.short_answer_html?.trim();
  if (html) return html;
  return card.short_answer?.trim() || "";
}

export function getReferenceCardFullAnswer(card: ReferenceCard): string {
  const html = card.answer_html?.trim();
  if (html) return html;
  return card.answer_markdown?.trim() || "";
}

// Plain text for copy / menu (strips tags from preferred HTML fields).
export function getReferenceCardsPlainText(message: Message): string {
  return getReferenceCards(message)
    .map((card) => {
      const parts = [
        card.question?.trim(),
        stripSimpleHtml(getReferenceCardShortAnswer(card)),
      ].filter(Boolean);
      return parts.join("\n");
    })
    .filter(Boolean)
    .join("\n\n");
}

function stripSimpleHtml(value: string): string {
  return value
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
